<template>
	<AddCompanyScope :dialogTitle="title" :centerDialogVisible="visible" @resetPopupData="resetPopupData"
		@submitPopupData="submitPopupData" :popupWidth="'800px'">
		<!-- <div class='search'>查询已添加企业</div>	 -->
		<div class='h-flex-align h-flex-space flex bottom10'>
			<!-- <e-search :data="query" :field-list="fieldList" :list-type-info="listTypeInfo" @handleFilter="handleSearch"/> -->
			<!-- @handleReset="handleClear" -->
			<div style='display:flex;'>
				<el-input size='medium' v-model='companyName'
					placeholder="查询已添加企业" style='font-size:12px;'/>
					<span class='handleSearch'  @click='handleSearch'>查 询</span>
			</div>
			<el-button type="primary" @click="addCompany" style="text-decoration:none;margin-bottom: 2px">添加企业
			</el-button>
		</div>

		<el-table :data="tableData" border>
			<el-table-column label="序号" type="index" />
			<!-- <el-table-column v-for="column in bindTableColumns" :key="column.prop" :prop="column.prop" :label="column.label" /> -->
			<el-table-column label="企业名称" type='text' prop='buyerCompanyName' align='center' />
			<el-table-column label="操作" width='100' align='center'>
				<template slot-scope="scope">
					<el-button type="text" @click="deleteScope(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pagination">
			<el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page.sync="query.pageNum"
				:page-sizes="[10, 20,50, 100, 200]" :page-size="query.pageSize" :total="pageTotal"
				@current-change="handleCurrentChange" @size-change='handleSizeChange' prev-text="上一页" next-text="下一页" />
		</div>
	</AddCompanyScope>

</template>

<script>
	import api from "../../api/company";
	import AddCompanyScope from '../../../../components/common/epecDialog'
	// import eSearch from "../../components/common/e-search";
	export default {
		name: "addCompanyScope",
		components: {
			AddCompanyScope,
			// eSearch
		},
		props: {
			title: {
				type: String,
				required: true
			},
			visible: {
				type: Boolean,
				required: true
			},
		},
		data() {
			return {
				query: {
					companyName: '',
					pageNum: 1,
					pageSize: 10
				},
				fieldList: [{
					label: '企业名称',
					type: 'input',
					value: 'companyName'
				}],
				listTypeInfo: {},
				tableColumns: [{
					prop: "buyerCompanyName",
					label: "企业名称",
					show: true
				}, ],
				tableData: [],
				pageTotal: 0,
				companyName:''
			}
		},
		computed: {
			// bindTableColumns() {
			// 	return this.tableColumns.filter((column) => column.show);
			// },

			/* 这里使用了getter和setter，这样写的好处不用自己手动监听复选框的选中事件 */
			// checkedTableColumns: {
			// 	get() {
			// 		// 返回选中的列名
			// 		return this.bindTableColumns.map(column => column.prop);
			// 	},
			// 	set(checked) {
			// 		// 设置表格列的显示与隐藏
			// 		this.tableColumns.forEach((column) => {
			// 			// 如果选中，则设置列显示
			// 			if (checked.includes(column.prop)) {
			// 				column.show = true;
			// 			} else {
			// 				// 如果未选中，则设置列隐藏
			// 				column.show = false;
			// 			}
			// 		})
			// 	}
			// },

		},
		created() {
			this.getData();
		},
		methods: {
			getData() {
				let params = {
					// companyId: 1234,
					companyName: this.query.companyName,
					pageNum: this.query.pageNum,
					pageSize: this.query.pageSize
				}
				api.buyerCompanyPage(params)
					.then((res) => {
						this.tableData = res.data.records;
						this.pageTotal = res.data.total;
					})
				this.query.companyName = ""
			},
			resetPopupData() {
				this.$emit('cancel')
			},
			submitPopupData() {
				this.$emit('save', this.param)
			},
			deleteScope(row) {
				let pm = {};
				pm.companyId = row.companyId;
				pm.buyerCompanyId = row.buyerCompanyId;
				pm.payType = row.payType;
				api.deleteBuyerCompany(pm)
					.then((res) => {
						if ('200' === res.code) {
							this.$message({
								showClose: true,
								message: '删除企业' + row.buyerCompanyName + '范围成功',
								type: 'success'
							});
							this.getData();
						} else {
							this.$message({
								showClose: true,
								message: '删除企业' + row.buyerCompanyName + '范围失败',
								type: 'error'
							});
						}
					})
			},
			handleSizeChange(val) {
				this.$set(this.query, "pageSize", val);
				this.getData();
			},
			handleCurrentChange(val) {
				this.$set(this.query, "pageNum", val);
				this.getData();
			},
			handleSearch() {
				console.log(this.companyName)
				this.query.companyName = this.companyName
				this.query.pageNum = 1;
				// this.query.companyName = val.companyName;
				this.getData();
			},
			handleClear() {
				// val.companyName = ""
				this.$emit('clear', "")
				this.query.companyName = ""
				this.companyName = ''
			},
			addCompany() {
				this.$emit('open')
			}
		}
	}
</script>

<style lang='scss' scoped>
	.search {
		width: 100%;
		text-align: left;
	}

	.flex {
		display: flex;
	}

	.h-flex-space {
		justify-content: space-between;
	}

	.h-flex-align {
		align-items: center;
	}

	.bottom10 {
		margin-bottom: 10px;
	}
	.handleSearch{
		display: inline-block;
		display:flex;
		align-items: center;
		justify-content: center;
		width:100px;
		height:36px;
		border:1px solid rgb(88,150,208);
		font-size:12px;
		color:rgb(88,150,208);
	}
	.handleSearch:hover{
		background-color: rgb(233,243,255); 
	}
</style>
